

























import hash from 'object-hash';
import PpNrSelect from '@/modules/ciselnik/dilenske/components/PpNrSelect.vue';
import { TabulkovaPozice } from '@/modules/ciselnik/dilenske/tabulkovaPozice';
import { PageMode } from '@/main/utils/pageMode';
import { listFactory } from '@/main/pages';
import { TABLE_SCHEMA } from '@/main/store/listEditTypes';
import { columnsToCamelCase, getColumnsRowMapObject } from '@/main/utils/table';
import DmsEditableTable from '#components/dms/layout/EditableTable.vue';
import Save from '#components/dms/button/Save.vue';
import { NAME, SET_LIST_TABLE_SCHEMA } from './constants';
import { store } from './store/list';
import { listMutations } from './store/types';
import { apiProvider } from './api';
import { convertToObjects } from '@/main/utils/table';

export default listFactory(NAME, store).extend({
	components: {
		PpNrSelect,
		TabulkovaPoziceSelect: TabulkovaPozice.components.Select,
		DmsEditableTable,
		'dms-save': Save,
	},
	computed: {
		mutationsMappers() {
			return {
				tabulkovaPozice: `${this.storeUri}/${listMutations.PRACOVNI_POZICE_TABULKOVA_POZICE_FILTER_SELECT_MAPPER}`,
				ppNr: `${this.storeUri}/${listMutations.PRACOVNI_POZICE_PP_NR_FILTER_SELECT_MAPPER}`,
			};
		},
		tablpozFilter() {
			return { VyrobekvozOzn: this.VyrobekvozOzn };
		},
		ppServiceNrFilter() {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				Tablpozice: this.Tablpozice,
				PpNr: this.PpNr ? this.PpNr.substring(0, 4) : null,
			};
		},
		ppDruhFilter() {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				PpServisNr: this.PpNr ? this.PpNr.substring(0, 4) : null,
				Tablpozice: this.Tablpozice,
			};
		},
		displayFilter() {
			if (this.props.showFilter === false) {
				return this.props.showFilter;
			}

			return this.props.mode !== PageMode.SELECT_LIST;
		},
		isModified(): boolean {
			return this.table.hash !== hash(this.table.rows);
		},
		saveDisabled(): boolean {
			return this.loading;
		},
	},
	methods: {
		async loadData() {
			await this.loadFilter();
			this.setFilterByParams();
			const schema = await this.schema();
			if(schema.message !== undefined)
			{
				return;	
			}
			if (!this.autoLoadItems) return;
			const { data } = await this.tableData();
			if (this.isSelectList && data.length === 1) {
				const rowData = getColumnsRowMapObject(columnsToCamelCase(schema.data.Columns), data[0].Cells);

				this.selectedRow({ data: rowData });
				this.$router.back();
			}
		},
		async schema() {
			if (this.Schemas[this.Type]) {
				return this.$store.dispatch(`${this.storeUri}/${SET_LIST_TABLE_SCHEMA}`, this.Schemas[this.Type]);
			}
			const result = await this.$store.dispatch(`${this.storeUri}/${TABLE_SCHEMA}`, { isSelect: this.isSelectList, type: this.Type });
			this.Schemas[this.Type] = result.data;
			return result;
		},
		async filterClick() {
			const schema = await this.schema();
			if(schema.message !== undefined)
			{
				return;	
			}
			await this.tableData();
		},
		async handleSave() {
			try {
				this.startLoading();
				await apiProvider.saveTable(convertToObjects(this.table));
			} finally {
				this.table.hash = hash(this.table.rows);
				this.endLoading();
			}
		},
	},
});
